import { readonly, ref, useContext } from '@nuxtjs/composition-api';
import { Logger } from '~/helpers/logger';
import { getProductListCommand } from '~/modules/catalog/product/composables/useProduct/commands/getProductListCommand';
import { getProductDetailsCommand } from '~/modules/catalog/product/composables/useProduct/commands/getProductDetailsCommand';
/**
 * Allows loading product details or list with
 * params for sorting, filtering and pagination.
 *
 * See the {@link UseProductInterface} for a list of methods and values available in this composable.
 */
export function useProduct(id) {
    const loading = ref(false);
    const error = ref({
        getProductList: null,
        getProductDetails: null,
    });
    const context = useContext();
    const getProductList = async (searchParams) => {
        Logger.debug(`useProduct/${id}/getProductList`, searchParams);
        let products = null;
        try {
            loading.value = true;
            products = await getProductListCommand.execute(context, searchParams);
            error.value.getProductList = null;
        }
        catch (err) {
            error.value.getProductList = err;
            Logger.error(`useProduct/${id}/search`, err);
        }
        finally {
            loading.value = false;
        }
        return products;
    };
    const getProductDetails = async (searchParams) => {
        Logger.debug(`useProduct/${id}/getProductDetails`, searchParams);
        let products = null;
        try {
            loading.value = true;
            products = await getProductDetailsCommand.execute(context, searchParams);
            error.value.getProductDetails = null;
        }
        catch (err) {
            error.value.getProductDetails = err;
            Logger.error(`useProduct/${id}/search`, err);
        }
        finally {
            loading.value = false;
        }
        return products;
    };
    const getProductPath = (product) => {
        var _a, _b, _c;
        if (!product)
            return '/';
        return `/${(_c = (_b = (_a = product === null || product === void 0 ? void 0 : product.url_rewrites) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.url) !== null && _c !== void 0 ? _c : (product.url_key || product.url.slice(product.url.lastIndexOf('/') + 1))}`;
    };
    return {
        getProductList,
        getProductDetails,
        getProductPath,
        error: readonly(error),
        loading: readonly(loading),
    };
}
export * from './useProduct';
export default useProduct;
